import React from "react";
import classNames from "classnames";

export default function Button({ className, type, ...otherProps }) {
  const buttonType = type || "button";
  const classnames = classNames(className, "Button");
  return <button className={classnames} type={buttonType} {...otherProps} />;
}
